// OnlinePage.jsx
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import online1 from "../../../assets/images/ychoose1.png"
import './online.css'; // New CSS file for enhanced design
import img1 from "../../../assets/images/autoscroll1.jpg";
import img2 from "../../../assets/images/autoscroll2.jpg";
import img3 from "../../../assets/images/autoscroll3.jpg";
import img4 from "../../../assets/images/autoscroll4.jpg";
import img5 from "../../../assets/images/autoscroll5.jpg";
import img6 from "../../../assets/images/autoscroll6.jpg";
import img7 from "../../../assets/images/autoscroll7.jpg";
import img8 from "../../../assets/images/autoscroll8.jpg";
import img9 from "../../../assets/images/autoscroll9.jpg";
import img10 from "../../../assets/images/autoscroll10.jpg";// SVG Icons (re-using from Home.jsx or similar context)
const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
  </svg>
);

const VideoCallIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z" />
  </svg>
);

const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" />
  </svg>
);

const DoctorIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M12,14C14.21,14 16,12.21 16,10C16,7.79 14.21,6 12,6C9.79,6 8,7.79 8,10C8,12.21 9.79,14 12,14M12,14.5C9.03,14.5 6,16.03 6,19V20H18V19C18,16.03 14.97,14.5 12,14.5Z" />
  </svg>
);

const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M19,3H18V1H16V3H8V1H6V3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V8H19V19Z" />
  </svg>
);

const LeafIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z" />
  </svg>
);

const CheckCircleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
  </svg>
);

const HairIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M12,3C10.6,3 9.2,3.4 8,4.2V5.2C8.8,4.5 10.4,4 12,4C13.6,4 15.2,4.5 16,5.2V4.2C14.8,3.4 13.4,3 12,3M4.2,8C3.4,9.2 3,10.6 3,12C3,13.4 3.4,14.8 4.2,16H5.2C4.5,15.2 4,13.6 4,12C4,10.4 4.5,8.8 5.2,8V8M16,19.8V18.8C15.2,19.5 13.6,20 12,20C10.4,20 8.8,19.5 8,18.8V19.8C9.2,20.6 10.6,21 12,21C13.4,21 14.8,20.6 16,19.8M19.8,16C20.6,14.8 21,13.4 21,12C21,10.6 20.6,9.2 19.8,8H18.8C19.5,8.8 20,10.4 20,12C20,13.6 19.5,15.2 18.8,16V16M12,7C9.2,7 7,9.2 7,12C7,14.8 9.2,17 12,17C14.8,17 17,14.8 17,12C17,9.2 14.8,7 12,7Z" />
  </svg>
);

const SkinIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6C9.24,6 7,8.24 7,11C7,13.76 12,19 12,19C12,19 17,13.76 17,11C17,8.24 14.76,6 12,6M12,8A3,3 0 0,1 15,11A3,3 0 0,1 12,14A3,3 0 0,1 9,11A3,3 0 0,1 12,8Z" />
  </svg>
);

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10V11H16V18H8V11H9.2V10C9.2,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.4,8.7 10.4,10V11H13.6V10C13.6,8.7 12.8,8.2 12,8.2Z" />
  </svg>
);

const AwardIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M5,16L3,5L8.5,12L12,5L15.5,12L21,5L19,16H5M12,8L10.5,11L12,14L13.5,11L12,8Z" />
  </svg>
);

const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
  </svg>
);

const LocationIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z" />
  </svg>
);


// API Configuration (re-using from Home.jsx context)
const API_CONFIG = {
  baseURL7001: "https://clinic-api.h-cura.com/",
  apiPath: "api/v1/",
  apiName: {
    apptFormFilling: "super_admin/patient/form/website",
  },
};





const OnlinePage = () => {
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    phoneNo: '',
    state: '',
    message: '',
    consultationType: 'online', // Default to online
    concern: '',
    branch: '' // Not relevant for online, but kept for consistency if needed
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [expandedFAQ, setExpandedFAQ] = useState(null);
  const [showAiNavigator, setShowAiNavigator] = useState(false); // State for AI Navigator modal

  const scrollerRef = useRef(null);
  const scrollerContentRef = useRef(null);
// Data for the infinite scroller with your merged transformation images
const transformationResultsData = [
  { id: 1, transformationImage: img1, altText: "Patient transformation result 1" },
  { id: 2, transformationImage: img2, altText: "Patient transformation result 2" },
  { id: 3, transformationImage: img3, altText: "Patient transformation result 3" },
  { id: 4, transformationImage: img4, altText: "Patient transformation result 4" },
  { id: 5, transformationImage: img5, altText: "Patient transformation result 5" },
  { id: 6, transformationImage: img6, altText: "Patient transformation result 6" },
  { id: 7, transformationImage: img7, altText: "Patient transformation result 7" },
  { id: 8, transformationImage: img8, altText: "Patient transformation result 8" },
  { id: 9, transformationImage: img9, altText: "Patient transformation result 9" },
  { id: 10, transformationImage: img10, altText: "Patient transformation result 10" },
];

// Inside your OnlinePage component function:
// const OnlinePage = () => {
//   // ... (existing state and other hooks)

  // Refs for the infinite scroller
  const galleryScrollerRef = useRef(null);
  const galleryTrackRef = useRef(null);

  useEffect(() => {
    // Duplicate content for infinite scroll
    if (galleryTrackRef.current) {
      const scrollerInner = galleryTrackRef.current;
      // Store original content to prevent multiple duplications on re-renders
      const originalContent = scrollerInner.innerHTML;
      if (!scrollerInner.dataset.originalContent) {
        scrollerInner.dataset.originalContent = originalContent;
      } else {
        scrollerInner.innerHTML = scrollerInner.dataset.originalContent; // Restore original before duplicating
      }
      scrollerInner.innerHTML += scrollerInner.innerHTML; // Duplicate content
    }
  }, [transformationResultsData]); // Re-run if transformationResultsData changes

  // ... (rest of your component's logic and return statement)

  const bounce = cssTransition({
    enter: 'bounceIn',
    exit: 'bounceOut',
    duration: [600, 300],
  });

  useEffect(() => {
    document.title = "H-Cura Online Consultation | Homeopathy & Aesthetic Treatments";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Book online homeopathy and aesthetic consultations with H-Cura. Get personalized treatment plans from expert doctors for hair, skin, and chronic conditions, all from the comfort of your home."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "online homeopathy, aesthetic consultation online, H-Cura online, virtual doctor, online hair treatment, online skin treatment, homeopathy online, remote consultation, digital healthcare"
      );
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phoneNo) {
      newErrors.phoneNo = "Phone number is required.";
    } else if (!/^[0-9]+$/.test(formData.phoneNo)) {
      newErrors.phoneNo = "Phone number can only contain numbers.";
    } else if (formData.phoneNo.length !== 10) {
      newErrors.phoneNo = "Phone number must be exactly 10 digits.";
    }
    if (!formData.concern.trim()) newErrors.concern = "Please select a concern";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${API_CONFIG.baseURL7001}${API_CONFIG.apiPath}${API_CONFIG.apiName.apptFormFilling}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status >= 200 && response.status < 300) {
        setShowSuccessMessage(true);
        setFormData({ ...formData, name: '', age: '', phoneNo: '', state: '', message: '', concern: '' }); // Reset relevant fields
        setErrors({});
      } else {
        toast.error(`Form submission failed: ${response.data.message || 'Server responded with an error.'}`, {
          position: 'top-center', transition: bounce, autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("An unexpected error occurred. Please try again.", {
        position: 'top-center', transition: bounce, autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const toggleFAQ = (index) => {
    setExpandedFAQ(expandedFAQ === index ? null : index);
  };

  const faqData = [
    {
      question: "How do online homeopathy consultations work?",
      answer: "Our online homeopathy consultations involve a detailed video call with our certified doctors. They will assess your symptoms, medical history, and lifestyle to create a personalized treatment plan. Medicines are then dispatched to your doorstep."
    },
    {
      question: "What aesthetic treatments can be discussed online?",
      answer: "You can discuss various aesthetic concerns online, including hair loss, skin issues like acne or pigmentation, and anti-aging solutions. Our specialists will provide initial assessments and guide you on suitable treatments and next steps, which might include in-clinic procedures."
    },
    {
      question: "Is online consultation as effective as in-clinic?",
      answer: "For many conditions, online consultations are highly effective. They offer convenience and accessibility. For homeopathy, the diagnostic process is primarily based on detailed case-taking, which is well-suited for online platforms. For aesthetic treatments, initial consultations and follow-ups are also effective online, though procedures require an in-clinic visit."
    },
    {
      question: "How do I receive my prescribed medicines?",
      answer: "After your online homeopathy consultation, your personalized medicines will be carefully packed and dispatched to your registered address. We partner with reliable courier services to ensure timely and safe delivery."
    },
    {
      question: "What technology do I need for an online consultation?",
      answer: "You'll need a smartphone, tablet, or computer with a stable internet connection, a working camera, and a microphone. Our platform is user-friendly and accessible via a web browser or our dedicated app."
    }
  ];

  // Placeholder for AI Navigator Modal - In a real app, this would be a complex component
  const AiNavigatorModal = ({ onClose }) => (
    <div className="hcura-ai-navigator-modal-overlay">
      <div className="hcura-ai-navigator-modal-content">
        <h3>H-Cura AI Wellness Navigator</h3>
        <p>This is a placeholder for your interactive AI-powered symptom checker/quiz.</p>
        <p>It would ask you questions about your concerns (homeopathy, hair, skin) and provide a summary for your doctor.</p>
        <button onClick={onClose} className="hcura-ai-navigator-close-btn">Close</button>
      </div>
    </div>
  );

  return (
    <div className="hcura-online-page-container">
      {showAiNavigator && <AiNavigatorModal onClose={() => setShowAiNavigator(false)} />}

      {/* <section className="hcura-online-hero-section_unique">
        <div className="hcura-online-hero-content_unique">
          <h1>Your Health, Your Comfort: Expert Online Homeopathy & Aesthetic Care</h1>
          <h2>Personalized Consultations, Natural Healing, Delivered to Your Doorstep</h2>
          <p>
            Experience the future of wellness with H-Cura's leading online specialists. Get precise diagnoses, custom treatment plans, and ongoing support, all from the convenience and privacy of your home.
          </p>
          <div className="hcura-hero-actions_unique">
            <a href="#hcura-consultation-form" className="hcura-online-cta-primary_unique">
              <VideoCallIcon /> Book Online Consultation
            </a>
            <a href="tel:+91-9964688333" className="hcura-online-cta-secondary_unique">
              <PhoneIcon /> Call Us: +91-99646 88333
            </a>
          </div>
        </div>
      </section> */}

    {/*  */}

 <section className="hcura-about-online-section_unique">
        <div className="hcura-about-online-content_unique">
          <span className="hcura-online-subtitle">Our Vision for Your Wellness</span>
          <h2>Expert Healthcare at Your Doorstep — H-Cura Online</h2>
          <p>
World-class healthcare, right where you are. H-Cura brings classical homeopathy and modern aesthetic treatments together — supported by certified doctors, personalized treatment plans, and continuous follow-up for complete, confidential care.      </p>
          <div className="hcura-about-online-features_unique">
            <div className="hcura-about-feature-item_unique">
              <ShieldIcon />
              <span>Secure & Confidential Consultations</span>
            </div>
            <div className="hcura-about-feature-item_unique">
              <AwardIcon />
              <span>Certified & Experienced Specialists</span>
            </div>
            <div className="hcura-about-feature-item_unique">
              <CheckCircleIcon />
              <span>Proven Results with Personalized Plans</span>
            </div>
          </div>
        
        </div>
        <div className="hcura-about-online-form_unique">
          <div className="hcura-quick-form-container_unique">
            <h3>Quick Consultation Request</h3>
            <form onSubmit={handleSubmit}>
              <div className="hcura-form-group_unique">
                <label htmlFor="quick-name_unique">Name:<span>*</span></label>
                <input
                  type="text"
                  id="quick-name_unique"
                  name="name"
                  placeholder="Your Full Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                {errors.name && <span className="hcura-error-message_unique">{errors.name}</span>}
              </div>

              <div className="hcura-form-group_unique">
                <label htmlFor="quick-phoneNo_unique">Phone Number:<span>*</span></label>
                <input
                  type="tel"
                  id="quick-phoneNo_unique"
                  name="phoneNo"
                  placeholder="10-digit Phone Number"
                  value={formData.phoneNo}
                  onChange={handleChange}
                  required
                />
                {errors.phoneNo && <span className="hcura-error-message_unique">{errors.phoneNo}</span>}
              </div>

              <div className="hcura-form-group_unique">
                <label htmlFor="quick-concern_unique">Select Your Concern:<span>*</span></label>
                <select
                  id="quick-concern_unique"
                  name="concern"
                  value={formData.concern}
                  onChange={handleChange}
                  required
                >
                  <option value="">Choose a concern...</option>
                  <option value="homeopathy">Homeopathy (e.g., chronic illness, wellness)</option>
                  <option value="aesthetic_hair">Aesthetic Hair (e.g., Hair Loss, thinning, scalp issues)</option>
                  <option value="aesthetic_skin">Aesthetic Skin (e.g., Acne, Anti-Aging, pigmentation)</option>
                </select>
                {errors.concern && <span className="hcura-error-message_unique">{errors.concern}</span>}
              </div>

     

              <button type="submit" className="hcura-quick-submit-button_unique" disabled={loading}>
                {loading ? 'Submitting...' : 'Request Consultation'}
              </button>
            </form>
          </div>
        </div>
      </section>


<section className="hcura-why-choose-hcura-section">
  <div className="hcura-why-choose-hcura-header">
    <span className="hcura-online-subtitle">The H-Cura Advantage</span>
    <h2>Why H-Cura Is the Preferred Choice for Holistic Wellness</h2>
    <p>Doctor-led evaluations, evidence-based treatment, and personalized healing plans for long-term wellness.</p>
  </div>
  
  <div className="hcura-why-choose-perfect-content">
    <div className="hcura-content-card">
      

      <div className="hcura-content-body">
        <p className="hcura-intro-line">
At H-Cura, our unique model merges traditional homeopathic principles with modern clinical aesthetics to enhance both health and appearance.          </p>

        <div className="hcura-content-divider"></div>

        <div className="hcura-content-line">
          <div className="hcura-line-icon"><LeafIcon /></div>
          <h3 className="hcura-line-heading">Integrated Multispecialty Excellence</h3>
          <p className="hcura-line-text">
Access complete care with expert homeopathy, advanced hair restoration, and scientifically backed skin aesthetics — all in one trusted medical center, eliminating scattered treatments and conflicting plans.          </p>
        </div>

        <div className="hcura-content-line">
          <div className="hcura-line-icon"><DoctorIcon /></div>
          <h3 className="hcura-line-heading">Elite, Doctor-Led Clinical Care</h3>
          <p className="hcura-line-text">
Led by board-certified experts with global exposure, our medical team combines years of experience with scientific precision. Every specialist is handpicked for advanced knowledge, compassionate care, and results-focused holistic treatment.          </p>
        </div>

        <div className="hcura-content-line">
          <div className="hcura-line-icon"><CheckCircleIcon /></div>
          <h3 className="hcura-line-heading">100% Personalized Treatment Protocols</h3>
          <p className="hcura-line-text">
We don’t treat a condition — we treat the individual behind it. Through in-depth medical evaluations and detailed case analysis, we design customized treatment plans that target the root cause and align with your body’s unique constitution for long-term results.          </p>
        </div>

       

        <div className="hcura-content-line">
          <div className="hcura-line-icon"><CalendarIcon /></div>
          <h3 className="hcura-line-heading">Ongoing Guidance From Start to Success</h3>
          <p className="hcura-line-text">
Your wellness is an evolving journey. Our care team provides continuous monitoring, timely follow-ups, and full-time support to help you achieve and sustain optimal health — every day, year after year.          </p>
        </div>

        <div className="hcura-content-line">
          <div className="hcura-line-icon"><AwardIcon /></div>
          <h3 className="hcura-line-heading">Trusted Results That Speak for Themselves</h3>
          <p className="hcura-line-text">
People across all age groups continue to choose H-Cura for reliable, long-term healing. Their testimonials and consistent outcomes showcase genuine transformation guided by expert, holistic treatment.          </p>
        </div>

        <div className="hcura-content-divider"></div>

        <p className="hcura-closing-line">
With H-Cura, you aren’t just receiving treatment; you’re joining a supportive healthcare family committed to evidence-based healing, technological excellence, and heartfelt care. Your path to lasting wellness starts now.        </p>
      </div>

      <div className="hcura-trust-statistics">
        <div className="hcura-stat-item">
          <span className="hcura-stat-number">50,000+</span>
          <span className="hcura-stat-label">Happy Patients</span>
        </div>
        <div className="hcura-stat-divider"></div>
        <div className="hcura-stat-item">
          <span className="hcura-stat-number">4.8★</span>
          <span className="hcura-stat-label">Patient Rating</span>
        </div>
        <div className="hcura-stat-divider"></div>
        <div className="hcura-stat-item">
          <span className="hcura-stat-number">15+</span>
          <span className="hcura-stat-label">Years Excellence</span>
        </div>
        <div className="hcura-stat-divider"></div>
        <div className="hcura-stat-item">
          <span className="hcura-stat-number">100%</span>
          <span className="hcura-stat-label">Natural Care</span>
        </div>
      </div>
    </div>
  </div>
</section>


<section className="hcura-homeopathy-explained-section">
  <div className="hcura-homeopathy-container">
    <div className="hcura-homeopathy-header">
      <span className="hcura-online-subtitle">Understanding Homeopathy</span>
      <h2>What is Homeopathy? Nature's Path to Holistic Healing</h2>
      <p>Discover the science, philosophy, and proven benefits of this 200-year-old natural healing system</p>
    </div>

    <div className="hcura-homeopathy-content">
      <div className="hcura-homeopathy-main-card">
        <div className="hcura-homeopathy-icon-large">
          <LeafIcon />
        </div>
        <div className="hcura-homeopathy-text">
          <h3>A Gentle, Natural Approach to Wellness</h3>
          <p>
Homeopathy is a holistic medical approach that traces its roots back more than two centuries, developed by Dr. Samuel Hahnemann. Operating on the principle that “like cures like,” it employs carefully diluted natural substances to gently activate your body’s innate healing processes. Rather than merely suppressing symptoms — as many conventional treatments do — homeopathy aims to address the underlying cause of illness, fostering deep and long-lasting well-being without harmful side effects.          </p>
          <p>
Globally acknowledged by the World Health Organization as one of the most widely practiced therapeutic systems, homeopathy supports healing of the whole person — body, mind, and spirit — not just isolated symptoms. Its gentle, non-invasive nature makes it suitable for individuals at every stage of life, from newborns to seniors, and effective for both acute ailments and chronic conditions.          </p>
        </div>
      </div>

      <div className="hcura-homeopathy-how-works">
        <h3>How Does Homeopathy Work?</h3>
        <div className="hcura-how-works-grid">
          <div className="hcura-how-works-card">
            <div className="hcura-how-works-number">1</div>
            <h4>Individualized Assessment</h4>
            <p>Your homeopath conducts a detailed consultation, understanding your physical symptoms, emotional state, lifestyle, and medical history to create your unique health profile.</p>
          </div>

          <div className="hcura-how-works-card">
            <div className="hcura-how-works-number">2</div>
            <h4>Custom Remedy Selection</h4>
            <p>Based on the principle of similars, a specific remedy is chosen that matches your complete symptom picture—addressing not just the disease, but you as an individual.</p>
          </div>

          <div className="hcura-how-works-card">
            <div className="hcura-how-works-number">3</div>
            <h4>Natural Healing Response</h4>
            <p>The remedy stimulates your body's vital force, activating its innate healing intelligence to restore balance and health from within, naturally and gently.</p>
          </div>

          <div className="hcura-how-works-card">
            <div className="hcura-how-works-number">4</div>
            <h4>Continuous Monitoring</h4>
            <p>Regular follow-ups ensure your treatment is progressing optimally. Remedies are adjusted as needed to support your journey to complete wellness.</p>
          </div>
        </div>
      </div>

      <div className="hcura-homeopathy-benefits">
        <h3>Why Choose Homeopathy?</h3>
        <div className="hcura-benefits-grid">
          <div className="hcura-benefit-item">
            <div className="hcura-benefit-icon">
              <CheckCircleIcon />
            </div>
            <div className="hcura-benefit-content">
              <h4>100% Natural & Safe</h4>
              <p>Made from natural substances with no harmful chemicals, safe for all ages including pregnant women and infants.</p>
            </div>
          </div>

          <div className="hcura-benefit-item">
            <div className="hcura-benefit-icon">
              <CheckCircleIcon />
            </div>
            <div className="hcura-benefit-content">
              <h4>No Side Effects</h4>
              <p>Gentle remedies that work with your body, not against it. No toxic reactions or drug dependencies.</p>
            </div>
          </div>

          <div className="hcura-benefit-item">
            <div className="hcura-benefit-icon">
              <CheckCircleIcon />
            </div>
            <div className="hcura-benefit-content">
              <h4>Treats Root Cause</h4>
              <p>Addresses underlying imbalances rather than just masking symptoms for deep, lasting healing.</p>
            </div>
          </div>

          <div className="hcura-benefit-item">
            <div className="hcura-benefit-icon">
              <CheckCircleIcon />
            </div>
            <div className="hcura-benefit-content">
              <h4>Holistic Approach</h4>
              <p>Treats the whole person—physical, mental, and emotional—for complete wellness transformation.</p>
            </div>
          </div>

          <div className="hcura-benefit-item">
            <div className="hcura-benefit-icon">
              <CheckCircleIcon />
            </div>
            <div className="hcura-benefit-content">
              <h4>Cost-Effective</h4>
              <p>Affordable treatment with long-lasting results, reducing the need for repeated medications.</p>
            </div>
          </div>

          <div className="hcura-benefit-item">
            <div className="hcura-benefit-icon">
              <CheckCircleIcon />
            </div>
            <div className="hcura-benefit-content">
              <h4>Complementary Care</h4>
              <p>Can be safely used alongside conventional treatments to enhance overall healing outcomes.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="hcura-conditions-treated">
        <h3>Conditions Successfully Treated with Homeopathy</h3>
        <div className="hcura-conditions-columns">
          <div className="hcura-condition-column">
            <h4>Chronic Diseases</h4>
            <ul>
              <li>Asthma & Allergies</li>
              <li>Arthritis & Joint Pain</li>
              <li>Diabetes Management</li>
              <li>Thyroid Disorders</li>
              <li>Digestive Issues (IBS, GERD)</li>
              <li>Migraine & Headaches</li>
            </ul>
          </div>

          <div className="hcura-condition-column">
            <h4>Skin Conditions</h4>
            <ul>
              <li>Eczema & Psoriasis</li>
              <li>Acne & Pimples</li>
              <li>Vitiligo</li>
              <li>Urticaria (Hives)</li>
              <li>Hair Loss & Dandruff</li>
              <li>Fungal Infections</li>
            </ul>
          </div>

          <div className="hcura-condition-column">
            <h4>Women's Health</h4>
            <ul>
              <li>PCOS & Menstrual Issues</li>
              <li>Infertility Support</li>
              <li>Pregnancy Care</li>
              <li>Menopausal Symptoms</li>
              <li>Leucorrhea</li>
              <li>Breast Disorders</li>
            </ul>
          </div>

          <div className="hcura-condition-column">
            <h4>Mental & Emotional</h4>
            <ul>
              <li>Anxiety & Depression</li>
              <li>Stress Management</li>
              <li>Sleep Disorders</li>
              <li>OCD & Phobias</li>
              <li>ADHD in Children</li>
              <li>Grief & Trauma</li>
            </ul>
          </div>
        </div>
      </div>

   <div className="hcura-homeopathy-cta">
  <h3>Ready to Experience Natural Healing?</h3>
  <p>Consult with our expert homeopaths online and start your journey to holistic wellness today.</p>

  <Link to="/bookconsultation" className="hcura-homeopathy-cta-btn">
    Book Consultation <ChevronRightIcon />
  </Link>
</div>

    </div>
  </div>
</section>





<section className="hcura-why-online-section">
  <div className="hcura-why-online-header">
    <span className="hcura-online-subtitle">Unlock Seamless Wellness</span>
    <h2>Why Online Consultation with H-Cura is Your Best Choice</h2>
    <p>Experience effortless healthcare, specialized medical attention, and constant guidance — all aligned with the demands of modern life..</p>
  </div>
  <div className="hcura-why-online-grid">
    <div className="hcura-why-online-card">
      <VideoCallIcon />
      <h3>Specialist Care at Your Convenience</h3>
      <p>Connect with board-certified homeopathy and aesthetic experts via secure virtual consultations, ensuring advanced medical care wherever you are — at home, at work, or traveling.</p>
    </div>
    <div className="hcura-why-online-card">
      <CalendarIcon />
      <h3>Convenient Appointment Timings</h3>
      <p>Book consultations at a time that works for you, including mornings, evenings, and weekends — without disrupting your day .</p>
    </div>
    <div className="hcura-why-online-card">
      <ShieldIcon />
      <h3>100% Private & Confidential</h3>
      <p>Speak freely about delicate concerns in a safe, private environment. Encrypted video consultations and secure record storage ensure your identity and medical information are always protected.</p>
    </div>
    <div className="hcura-why-online-card">
      <HomeIcon />
      <h3>Medicine Delivered to Your Door</h3>
      <p>Get customized homeopathic medicines conveniently shipped to your address.Enjoy easy tracking and seamless refills without a pharmacy visit.</p>
    </div>
    <div className="hcura-why-online-card">
      <DoctorIcon />
      <h3>Personalized Treatment Plans</h3>
      <p>We build treatment plans that reflect your unique health profile. Through detailed assessment and lifestyle understanding, our doctors create protocols designed specifically for your needs.</p>
    </div>
    <div className="hcura-why-online-card">
      <CheckCircleIcon />
      <h3>Continuous Follow-up Support</h3>
      <p>We stay with you even after treatment begins, offering routine check-ins, monitored progress, and full-time chat support to ensure steady and lasting recovery.</p>
    </div>
  </div>
</section>



<section className="hcura-online-how-it-works-section">
  <div className="hcura-online-how-it-works-header">
    <span className="hcura-online-subtitle">Simple Steps</span>
    <h2>Your Journey to Wellness in 3 Easy Steps</h2>
    <p>
From consultation to recovery, experience a smooth online care process tailored for your comfort and convenience.    </p>
  </div>
  
  <div className="hcura-online-process-timeline">
    <div className="hcura-process-step">
      <div className="hcura-step-icon">1</div>
      <div className="hcura-step-content">
        <h3>Book & Connect</h3>
        <p>Select a convenient time slot and meet our certified doctors online through a safe and private video session. Skip waiting rooms and commuting — your treatment begins instantly.</p>
        <div className="hcura-step-features">
          <span className="hcura-feature-tag">📅 Flexible Scheduling</span>
          <span className="hcura-feature-tag">🔒 100% Secure</span>
          <span className="hcura-feature-tag">⚡ Instant Access</span>
        </div>
      </div>
    </div>

    <div className="hcura-process-step hcura-step-highlight">
      <div className="hcura-step-icon">2</div>
      <div className="hcura-step-content">
        <h3>Personalized Diagnosis & Treatment Plan</h3>
        <p> Our doctors perform a complete health evaluation, considering your symptoms, medical history, and lifestyle factors. You receive a customized treatment plan designed specifically for your unique needs and body constitution.</p>
        <div className="hcura-step-features">
          <span className="hcura-feature-tag">🩺 Detailed Assessment</span>
          <span className="hcura-feature-tag">📋 Custom Protocol</span>
          <span className="hcura-feature-tag">💊 Precise Prescription</span>
        </div>
      </div>
    </div>

    <div className="hcura-process-step">
      <div className="hcura-step-icon">3</div>
      <div className="hcura-step-content">
        <h3>Medicine Delivery & Continuous Care</h3>
        <p>We prepare and ship your personalized medicines right to your address, complete with delivery tracking. You also remain supported through consistent follow-ups, detailed progress assessments, and anytime access to your care team.</p>
        <div className="hcura-step-features">
          <span className="hcura-feature-tag">🚚 Doorstep Delivery</span>
          <span className="hcura-feature-tag">📊 Progress Tracking</span>
          <span className="hcura-feature-tag">💬 24/7 Support</span>
        </div>
      </div>
    </div>
  </div>

  <div className="hcura-how-it-works-cta">
    <p>Ready to start your healing journey?</p>
    <a href="#hcura-consultation-form" className="hcura-how-it-works-btn">
      Book Your Consultation Now
    </a>
  </div>
</section>



  

      <section className="hcura-transformation-gallery-section">
          <div className="hcura-transformation-gallery-header">
            <span className="hcura-online-subtitle">Real Transformations</span>
            <h2>See the H-Cura Difference: Real Results, Real Transformations</h2>
            <p>View evidence-based improvements that illustrate the lasting impact of tailored therapeutic protocols.</p>
          </div>
          
          <div className="hcura-gallery-scroller" ref={galleryScrollerRef}>
            <div className="hcura-gallery-track" ref={galleryTrackRef}>
              {transformationResultsData.map((item) => (
                <div key={item.id} className="hcura-gallery-image-card"> 
                  <div className="hcura-gallery-image-wrapper">
                    <img src={item.transformationImage} alt={item.altText} className="hcura-gallery-image" />
                  
                  </div>
                 
                </div>
              ))}
            </div>
          </div>
          
          <div className="hcura-gallery-cta">
            <p>Ready to discover what your transformation could look like?</p>
            <a href="#hcura-consultation-form" className="hcura-gallery-cta-btn">
              Begin Your Journey Today
            </a>
          </div>
        </section>


      <section className="hcura-app-section">
        <div className="hcura-app-content">
          <span className="hcura-online-subtitle">Wellness On-The-Go</span>
          <h2>Your Wellness Companion: The H-Cura Mobile App</h2>
          <p>Empower your healing journey using the H-Cura app. Access expert consultations, monitor changes and receive curated health advice directly on your device.</p>
          <div className="hcura-app-features-list">
            <div className="hcura-app-feature-item">
              <CheckCircleIcon />
              <span>Instant Consultations & Appointments</span>
            </div>
            <div className="hcura-app-feature-item">
              <CheckCircleIcon />
              <span>Personalized Treatment Tracking</span>
            </div>
            <div className="hcura-app-feature-item">
              <CheckCircleIcon />
              <span>Secure Health Records Access</span>
            </div>
            <div className="hcura-app-feature-item">
              <CheckCircleIcon />
              <span>Medicine Reminders & Delivery Tracking</span>
            </div>
            <div className="hcura-app-feature-item">
              <CheckCircleIcon />
              <span>Exclusive Expert Health Tips</span>
            </div>
          </div>
          <div className="hcura-app-download-buttons">
            <a href="#" className="hcura-app-download-btn">
              <DownloadIcon /> Download on App Store
            </a>
            <a href="#" className="hcura-app-download-btn">
              <DownloadIcon /> Get it on Google Play
            </a>
          </div>
        </div>
        <div className="hcura-app-mockup">
          <img src={online1} alt="H-Cura Mobile App" />
        </div>
      </section>

   

 

      <section className="hcura-online-faq-section">
        <div className="hcura-online-faq-header">
          <span className="hcura-online-subtitle">Got Questions?</span>
          <h2>Frequently Asked Questions</h2>
          <p>Find answers to common queries about our online consultation services.</p>
        </div>
        <div className="hcura-online-faq-list">
          {faqData.map((faq, index) => (
            <div key={index} className="hcura-online-faq-item">
              <button
                className="hcura-online-faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <ChevronDownIcon className={expandedFAQ === index ? 'rotated' : ''} />
              </button>
              {expandedFAQ === index && (
                <div className="hcura-online-faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default OnlinePage;
